var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCoursioLogotype = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 52,
    viewBox: "0 0 285 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7845 25.9654C68.7845 16.1412 75.4681 8.5863 85.3909 8.5863C91.4523 8.5863 95.0362 11.0582 97.5863 14.3564L94.1421 17.4467C91.9366 14.4252 89.1127 13.1902 85.6666 13.1902C78.6385 13.1902 74.1586 18.6149 74.1586 25.9654C74.1586 33.316 78.6385 38.8132 85.6666 38.8132C89.1127 38.8132 91.9366 37.4389 94.1421 34.486L97.5863 37.6469C95.0362 40.9433 91.4523 43.417 85.3909 43.417C75.4681 43.417 68.7845 35.7897 68.7845 25.9654Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.449 25.9654C130.449 19.2333 126.52 13.1902 119.425 13.1902C112.326 13.1902 108.4 19.2333 108.4 25.9654C108.4 32.77 112.326 38.8132 119.425 38.8132C126.52 38.8132 130.449 32.77 130.449 25.9654ZM102.955 25.9654C102.955 16.3473 109.295 8.5863 119.425 8.5863C129.553 8.5863 135.892 16.3473 135.892 25.9654C135.892 35.5836 129.553 43.417 119.425 43.417C109.295 43.417 102.955 35.5836 102.955 25.9654Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.754 42.5928V37.9203C164.206 40.8044 159.866 43.4174 154.901 43.4174C147.944 43.4174 144.293 39.9817 144.293 32.8335V9.41125H149.46V31.2568C149.46 37.0975 152.422 38.8135 156.971 38.8135C160.968 38.8135 164.826 36.4773 166.754 33.7974V9.41125H171.921V42.5928H166.754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.254 42.5928V9.41125H187.419V14.7004C190.107 11.2647 193.967 8.65353 198.514 8.65353V13.9445C197.895 13.8758 197.273 13.8071 196.517 13.8071C193.277 13.8071 188.937 16.4182 187.419 19.0962V42.5928H182.254Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.161 38.1947L204.78 34.486C206.985 37.0266 211.186 39.2236 215.736 39.2236C220.835 39.2236 223.661 36.8204 223.661 33.5222C223.661 25.4863 203.057 30.4337 203.057 18.1357C203.057 12.9134 207.466 8.5863 215.392 8.5863C221.11 8.5863 225.104 10.7146 227.723 13.3944L225.313 16.9676C223.314 14.5626 219.732 12.776 215.392 12.776C210.845 12.776 208.019 15.0417 208.019 17.9983C208.019 25.2114 228.619 20.472 228.619 33.3866C228.619 38.9506 224.143 43.417 215.597 43.417C210.085 43.417 205.538 41.6992 202.161 38.1947Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.023 42.5917H242.19V9.41016H237.023V42.5917Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.088 25.9654C278.088 19.2333 274.157 13.1902 267.062 13.1902C259.965 13.1902 256.038 19.2333 256.038 25.9654C256.038 32.77 259.965 38.8132 267.062 38.8132C274.157 38.8132 278.088 32.77 278.088 25.9654ZM250.594 25.9654C250.594 16.3473 256.934 8.5863 267.062 8.5863C277.192 8.5863 283.531 16.3473 283.531 25.9654C283.531 35.5836 277.192 43.417 267.062 43.417C256.934 43.417 250.594 35.5836 250.594 25.9654Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.085 31.1987C23.2071 31.1987 20.8638 33.5238 20.8638 36.408C20.8638 39.2643 23.2071 41.5913 26.085 41.5913C28.9667 41.5913 31.2989 39.2643 31.2989 36.408C31.2989 33.5238 28.9667 31.1987 26.085 31.1987Z",
    fill: "#10D6D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.085 10.3965C23.2071 10.3965 20.8638 12.7328 20.8638 15.5909C20.8638 18.4732 23.2071 20.7909 26.085 20.7909C28.9667 20.7909 31.2989 18.4732 31.2989 15.5909C31.2989 12.7328 28.9667 10.3965 26.085 10.3965Z",
    fill: "#10D6D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.95 20.7903C44.0683 20.7903 41.7306 23.1266 41.7306 26.0071C41.7306 28.8726 44.0683 31.1978 46.95 31.1978C49.8242 31.1978 52.1564 28.8726 52.1564 26.0071C52.1564 23.1266 49.8242 20.7903 46.95 20.7903Z",
    fill: "#10D6D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21456 41.5916C2.33289 41.5916 0.000732422 43.9446 0.000732422 46.8009C0.000732422 49.6758 2.33289 51.9991 5.21456 51.9991C8.09995 51.9991 10.4396 49.6758 10.4396 46.8009C10.4396 43.9446 8.09995 41.5916 5.21456 41.5916Z",
    fill: "#10D6D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2148 0C2.33313 0 0.000976562 2.33629 0.000976562 5.19629V26.0056C0.000976562 28.8711 2.33313 31.1981 5.2148 31.1981C8.10019 31.1981 10.4398 28.8711 10.4398 26.0056V5.19629C10.4398 2.33629 8.10019 0 5.2148 0Z",
    fill: "#10D6D8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoursioLogotype, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coursio-logotype.955dd07b.svg";
export { ForwardRef as ReactComponent };